import { pathOr } from 'ramda'
import { SERVER_URL, LOAD_AMMOUNT } from '../../constants'

export const imagePrefix = `${SERVER_URL}/uploads/posts/thumbs/`

export const imagePrefix89 = `${SERVER_URL}/uploads/posts89/thumbs/`

export const audioPrefix = `${SERVER_URL}/uploads/posts/`

export const audioPrefix89 = `${SERVER_URL}/uploads/posts89/`

export const idFromUrl = (url) => {
  // new shortlink: https://youtu.be/mMtGDMdDlCU
  if (url.includes('youtu.be/')) {
    return url.split('youtu.be/')[1]
  }

  const id = url.split('v=')[1]
  const ampersandPosition = id.indexOf('&')
  if (ampersandPosition !== -1) {
    return id.substring(0, ampersandPosition)
  }
  return id
}

export const audioSrcFromProps = (props, is89) => {
  const audioName = pathOr(null, ['files', 0], props)
  const prefix = is89 ? audioPrefix89 : audioPrefix
  return audioName && `${prefix}${audioName}`
}

export const typeFromProps = (props) => {
  if (props.youtube) return 'Video'
  if (props.images.length > 1) return 'Fotoalbum'
  if (props.images.length === 1) return 'Fotka'
  if (props.files.length === 1) return 'Audio'
  return 'Text'
}

export const getHasMorePosts = (incommingPostsCount, loadedPostsCount) => {
  if (loadedPostsCount === 0) return false
  return incommingPostsCount === LOAD_AMMOUNT
}



// WEBPACK FOOTER //
// ./src/components/Post/helpers.js